var app = angular.module('leonardo');

var SectorNameFilter = function (SectorRestService) {
  return function (sectorId) {
    if (!sectorId) {
      return 'Not specified yet';
    }
    var sectors = SectorRestService.getCollection();
    var name = '';
    if (angular.isArray(sectorId)) {
      angular.forEach(sectors, function(sector) {
        if (_.contains(sectorId, sector.id)) {
          name += sector.name + ', ';
        }
      });
      return name.slice(0, -2);
    }
    else {
      angular.forEach(sectors, function(sector) {
        if (sector.id == sectorId) {
          name = sector.name;
        }
      });
      return name;
    }
  };
};

app.filter('sectorName', ['SectorRestService', SectorNameFilter]);

var SectorsNameFilter = function (SectorRestService) {
  return function (sectors) {
    if (isEmpty(sectors)) {
      return 'All sectors';
    }
    var name = [];
    if (sectors[0].id) {
      angular.forEach(sectors, function(sector) {
        name.push(sector.name);
      });
    }
    else {
      var collection = SectorRestService.getCollection();
      angular.forEach(collection, function(sector) {
        if (_.contains(sectors, sector.id)) {
          name.push(sector.name);
        }
      });
    }
    return name.join(', ');
  };
};

app.filter('sectorsName', ['SectorRestService', SectorsNameFilter]);